<template>
  <div class="pageBottomShow">
    <div class="bottomMain">
      <div class="logos">
        <img class="baseLogo" :src="imagePathLogo" alt="">
        <div class="commonLogos">
          <img v-for="item in iconLink" :key="item.id" @click="imgLinkClick(item)"
               class="commonLogoImg" :src="require('@/assets/imgs/commonIcon/' + item.id + '.png')" alt="">
          <!--<img class="commonLogoImg" src="@/assets/imgs/commonIcon/twitter.png" alt="">-->
          <!--<img class="commonLogoImg" src="@/assets/imgs/commonIcon/youtube.png" alt="">-->
          <!--<img class="commonLogoImg" src="@/assets/imgs/commonIcon/email.png" alt="">-->
        </div>
      </div>
      <div class="extText">
        <div class="ruleList">
          <div class="ruleListShow" v-for="(item,i) in rules" :key="item.id + 'bottomRule'">
            <span @click="rulesClick(item)" class="listText">{{item.label}}</span>
            <span v-if="i < rules.length - 1" class="rightLine"></span>
          </div>
        </div>
        <div class="otherInfo">
          <div class="ownership">
            {{ownership[language]}}
          </div>
          <div class="ownership">
            {{copyright[language]}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const iconMap = {
  tw: 'tc',
  kr: 'korean',
  jp: 'japan'
}
export default{
  name: 'PageBottom',
  components: {},
  data() {
    return{
      ownership: {
        japan: "©2024 WildCaly All Rights Reserved.",
        korean: "©2024 WildCaly All Rights Reserved."
      },
      copyright: {
        japan: "Major League Baseballの商標及び著作権はMajor League Baseballの許可を得て使用しております。詳細はMLB.comにてご確認ください。MLB Players, Inc.の公式ライセンス製品です。MLB Players, Inc.の商標、著作物及びその他の知的財産権は、MLB Players, Inc.の書面同意なく使用することはできません。MLBPLAYERS.comにアクセスしてご確認ください.",
        korean: "Major League Baseball의 상표와 저작권은 Major League Baseball의 허가를 받아 사용되었습니다. 자세한 사항은 MLB.com을 방문해서 확인해보세요. MLB Players, Inc.의 공식 라이선스 제품으로 MLBPA 상표, 저작물 및 기타 지적 재산권은 MLBPA에게 있으며, MLBPA 또는 MLB Players, Inc.의 서면 동의 없이는 사용할 수 없습니다. www.MLBPLAYERS.com에 방문해서 \"the Players Choice\"를 확인해보세요."
      }
    }
  },
  computed: {
    imagePathLogo() {
      return require(`@/assets/imgs/${iconMap[this.$i18n.locale]}/logo.png`);
    }
  },
  props: {
    rules: {
      type: Array,
      default: () => [
        {id: 'terms',label: '利用規約'},
        {id: 'privacyPolicy',label: 'プライバシーポリシー'},
        {id: 'exchangeAct',label: '特定商品取引法に基づき表示'},
        {id: 'payment',label: '資金決済法に基づき表示'},
      ],
    },
    language: {
      type:String,
      default: 'japan'
    },
    iconLink: {
      type: Array,
      default: () => []
    }
  },
  mounted() {},
  methods: {
    imgLinkClick(row){
      window.open(row.url,'_blank');
    },
    rulesClick(row){
      // this.$emit('rulesClick',row)
      window.open(row.url,'_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
.pageBottomShow{
  padding: 20px 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0c2659;
  .bottomMain{
    flex: 1;
    .logos{
      width: 100%;
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid white;
      @media screen and (max-width: 1920px){
        .baseLogo{
          height: 40px;
        }
      }
      @media screen and (min-width: 1921px){
        .baseLogo{
          height: 60px;
        }
      }
      .commonLogos{
        display: flex;
        @media screen and (max-width: 1920px){
          .commonLogoImg{
            margin-left: 10px;
            height: 40px;
          }
        }
        @media screen and (min-width: 1921px){
          .commonLogoImg{
            margin-left: 10px;
            height: 60px;
          }
        }
      }
    }
    .extText{
      padding: 5px 0;
      .ruleList{
        display: flex;
        @media screen and (max-width: 1920px){
          .ruleListShow{
            color: white;
            display: flex;
            align-items: center;
            .listText{
              cursor: pointer;
            }
            .rightLine{
              height: 20px;
              width: 2px;
              display: inline-block;
              background-color: white;
              margin: 0 8px;
            }
          }
        }
        @media screen and (min-width: 1921px){
          .ruleListShow{
            color: white;
            display: flex;
            align-items: center;
            font-size: 20px;
            .listText{
              cursor: pointer;
            }
            .rightLine{
              height: 20px;
              width: 2px;
              display: inline-block;
              background-color: white;
              margin: 0 8px;
            }
          }
        }
      }
      .otherInfo{
        color: white;
        @media screen and (max-width: 1920px){
          .ownership{
            text-align: right;
          }
        }
        @media screen and (min-width: 1921px){
          .ownership{
            text-align: right;
            font-size: 20px;
          }
        }
      }
    }
  }
}
</style>
